import {
  animate,
  Tween
} from '@js/public/mUtils'

// 点击焦点动画效果显示蓝色标题
export const IptFocus = (element) => {
  console.log('animation.js')
  // 平滑变化透明度
  animate(element, {
    opacity: 100
  }, 50, 0.2, null)
  // 利用运动曲线向上运动
  var t = 0,
    b = 0,
    c = 20,
    d = 20;
  var step = function () {
    // value就是当前的位置值
    // 设置DOM.style.left = value + 'px'实现定位
    var value = Tween.Quad.easeOut(t, b, c, d);
    element.style.top = (20 - value) + 'px'
    t++;
    if (t <= d) {
      // 继续运动
      requestAnimationFrame(step);
    } else {
      // 动画结束
    }
  };
  if (element.style.top !== '0px') { // 禁止二次运动
    step()
  }
};
export const getBefore = (code) => {
  return code.substring(code.length - 2, code.length)
}
/*禁止body滚动 配合样式使用才有效果*/
export const NoScroll = (code) => {
  document.getElementsByTagName('html')[0].className = 'no-scroll'
  document.getElementsByTagName('body')[0].className = 'no-scroll'
}
export const Scroll = (code) => {
  document.getElementsByTagName('html')[0].className = ''
  document.getElementsByTagName('body')[0].className = ''
}


// WEBPACK FOOTER //
// ./src/assets/js/public/animation.js